export const mergePortfolioImages = (existingImages = [], newImages = []) => [
  ...(Array.isArray(existingImages) ? existingImages : []),
  ...(Array.isArray(newImages) ? newImages : []),
];

export const createPortfolioImageRecord = ({ url, now = Date.now }) => ({
  url,
  caption: "",
  featured: false,
  createdAt: now(),
});

export const uploadPortfolioFiles = async ({
  files = [],
  userId,
  storage,
  storageRef,
  uploadBytesResumable,
  getDownloadURL,
  safeFileName,
  onProgress,
  now = Date.now,
}) => {
  if (!userId) {
    throw new Error("User is required to upload portfolio photos.");
  }

  const uploadedImages = [];
  const pendingFiles = Array.from(files || []);

  for (const [index, file] of pendingFiles.entries()) {
    const timestamp = now();
    const imageRef = storageRef(
      storage,
      `workImages/${userId}/${timestamp}_${index}_${safeFileName(file.name)}`
    );

    const uploadTask = uploadBytesResumable(imageRef, file, {
      contentType: file.type,
    });

    await new Promise((resolve, reject) => {
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          if (snapshot.totalBytes > 0 && typeof onProgress === "function") {
            const percent =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            onProgress(Math.round(percent));
          }
        },
        reject,
        resolve
      );
    });

    const url = await getDownloadURL(uploadTask.snapshot.ref);
    uploadedImages.push(createPortfolioImageRecord({ url, now }));
  }

  return uploadedImages;
};

export const appendPortfolioImagesToUserProfile = async ({
  db,
  userId,
  firestoreDoc,
  getDoc,
  setDoc,
  serverTimestamp,
  uploadedImages = [],
}) => {
  if (!userId) {
    throw new Error("User is required to save portfolio photos.");
  }

  const userRef = firestoreDoc(db, "users", userId);
  const snap = await getDoc(userRef);
  const existingData = snap.exists() ? snap.data() : {};
  const updatedWorkImages = mergePortfolioImages(
    existingData.workImages,
    uploadedImages
  );

  await setDoc(
    userRef,
    { workImages: updatedWorkImages, updatedAt: serverTimestamp() },
    { merge: true }
  );

  return { existingData, updatedWorkImages };
};
